import React, { Component } from "react";
import axios from "axios";
import { API as url1 } from "../../config";
import { GET_EMAIL_MOBILE_PATH } from "../../constants/url";

import  Swal  from "sweetalert2/dist/sweetalert2";
import { Link } from "react-router-dom";
import { ERR_GETTING } from "../../constants/alertMessage";

class MobileResetpassword extends Component {
  constructor() {
    super();
    this.state = {
      email: "",
      password: "",
      confirm_pass: "",
    };
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
    this.handleconfirmPasswordChange =
      this.handleconfirmPasswordChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    window.postMessage("renderTable", "*");
  }

  componentDidMount() {
    axios
      .get(
        `${url1}${GET_EMAIL_MOBILE_PATH}/${this.props.match.params.token}/?role=manager`
      )
      .then(
        (res) => {
          if (res.data.result === "success") {
            this.setState({ email: res.data.datas[0].email });
          } else {
            this.setState({ email: "" });
            Swal.fire({
              title: "Your Secure Token is expired",
              icon: "error",
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          }
        },
        (err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${ERR_GETTING}`,
            confirmButtonText: 'OK'  
          });
        }
      )
      .catch(()=>{
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: `${ERR_GETTING}`,
            confirmButtonText: 'OK'  
          });
      })
  }

  handleemailChange(event) {
    this.setState({ email: event.target.value });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }
  handleconfirmPasswordChange(event) {
    this.setState({ confirm_pass: event.target.value });
  }
  handleSubmit(event) {
    if (this.state.password.length < 6) {
      Swal.fire({
        title: "Your password must contain 6 letter",
        icon: "error",
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    } else {
      if (this.state.password === this.state.confirm_pass) {
        event.preventDefault();
        axios
          .post(
            url1 + "/mobile/resetpassword/" + this.props.match.params.token,
            {
              password: this.state.password,
              secure_token: this.props.match.params.token,
            }
          )
          .then(
            (res) => {
              Swal.fire({
                title: "Password changed successfully",
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
              document.location = "/";
            },
            (err) => {
              Swal.fire({
                title: "Incorrect password",
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            }
          );
      } else {
        Swal.fire({
          title: "Password & Confirm Password  is Mismatched",
          icon: "error",
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      }
    }
  }

  render() {
    return (
      <section>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="wrapper-page">
                <div className="account-pages">
                  <div className="account-box">
                    <div className="account-logo-box">
                      <h2 className="text-uppercase text-center">
                        <Link to="/" className="text-success">
                          <span>
                            <img src="assets/images/LOGO-MAIN.png" alt="" />
                          </span>
                        </Link>
                      </h2>
                    </div>
                    <div className="account-content">
                      <div className="text-center m-b-20">
                        <h3>Reset Password</h3>
                      </div>
                      <form
                        className="form-horizontal"
                        onSubmit={this.handleSubmit}
                      >
                        <div className="form-group m-b-20 row">
                          <div className="col-12">
                            <label for="emailaddress">Email address</label>
                            <input
                              className="form-control"
                              type="email"
                              id="emailaddress"
                              value={this.state.email}
                              readOnly
                            />
                          </div>
                        </div>

                        <div className="form-group row m-b-20">
                          <div className="col-12">
                            <label for="password">New Password</label>
                            <input
                              className="form-control"
                              type="password"
                              required=""
                              id="password"
                              placeholder="Enter your password"
                              onChange={this.handlePasswordChange}
                            />
                          </div>
                        </div>

                        <div className="form-group row m-b-20">
                          <div className="col-12">
                            <label for="password">Confirm New Password</label>
                            <input
                              className="form-control"
                              type="password"
                              required=""
                              id="password"
                              placeholder="Re-enter your password"
                              onChange={this.handleconfirmPasswordChange}
                            />
                          </div>
                        </div>

                        <div className="form-group row text-center m-t-10">
                          <div className="col-12">
                            <button
                              className="btn btn-block waves-effect waves-light"
                              style={{ backgroundColor: "#11abff" }}
                              type="submit"
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default MobileResetpassword;
